module.exports = __webpack_public_path__ + "images/mobile_ad_icon_android.png";